/**
 * @fileoverview RiddleLayoutOnlyImage - Formato 3 (Solo Imagen):
 * Imagen / Silueta de alto impacto visual centrada y ensanchada (hasta 85vw / 1400px máx, 65vh máx).
 * Diseñado para un protagonismo visual imponente de la silueta / imagen revelada en la pantalla gigante.
 * Aceleración por GPU (Layer Compositing), alta visibilidad en 1080p y 4K.
 * 
 * @module components/Screen/Sections/Riddle/RiddleLayoutOnlyImage
 */

import React from 'react';

/**
 * Resuelve la URL absoluta de un recurso multimedia.
 * @param {string} url - URL relativa o absoluta.
 * @returns {string} URL resuelta.
 */
const resolveMediaUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:') || url.startsWith('data:')) {
        return url;
    }
    const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api/', '/').replace('/api', '/');
    return `${apiBase}${url.startsWith('/') ? url.substring(1) : url}`;
};

/**
 * Componente Layout Solo Imagen para la Pantalla Gigante de Adivina Adivinador.
 * 
 * @param {Object} props
 * @param {Object} props.riddle - Datos de la adivinanza (image, response, instruction, etc.).
 * @param {boolean} props.isItemVisible - Indica si la silueta ya fue revelada en color.
 * @param {string} [props.fontFamily] - Familia tipográfica institucional.
 * @param {string} [props.textColor] - Color principal de los textos.
 * @returns {React.ReactElement}
 */
export const RiddleLayoutOnlyImage = ({
    riddle,
    isItemVisible = false,
    fontFamily = '"GFS Didot", serif',
    textColor = '#FFFFFF'
}) => {
    const silhouetteImage = resolveMediaUrl(riddle?.image);
    const revealedImage = resolveMediaUrl(riddle?.response?.image) || silhouetteImage;
    const responseText = riddle?.response?.text || '';

    return (
        <section className="RiddleLayout RiddleLayout--OnlyImage">
            <div className="RiddleLayout__HeroContainer">
                <div className={`RiddleLayout__HeroCard ${isItemVisible ? 'RiddleLayout__HeroCard--Revealed' : 'RiddleLayout__HeroCard--Silhouette'}`}>
                    <div className="RiddleLayout__HeroImageWrapper">
                        <img
                            src={isItemVisible ? revealedImage : silhouetteImage}
                            alt={isItemVisible ? 'Personaje Revelado' : 'Silueta Misteriosa Centrada'}
                            className={`RiddleLayout__HeroImage ${isItemVisible ? 'RiddleLayout__HeroImage--Color' : 'RiddleLayout__HeroImage--Silhouette'}`}
                        />
                    </div>

                    {/* Cartel flotante central con el nombre revelado */}
                    {isItemVisible && responseText && (
                        <div className="RiddleLayout__HeroRevealedBanner">
                            <i className="bi bi-stars RiddleLayout__HeroRevealedBanner__Icon" />
                            <h2
                                className="RiddleLayout__HeroRevealedBanner__Title"
                                style={{ fontFamily, color: textColor }}
                            >
                                {responseText}
                            </h2>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default RiddleLayoutOnlyImage;
